import { render, staticRenderFns } from "./panoramic-hotel.vue?vue&type=template&id=ab1d55ae&scoped=true&"
import script from "./panoramic-hotel.vue?vue&type=script&lang=js&"
export * from "./panoramic-hotel.vue?vue&type=script&lang=js&"
import style0 from "./panoramic-hotel.vue?vue&type=style&index=0&id=ab1d55ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1d55ae",
  null
  
)

export default component.exports